import React from 'react';

import { ContextualInviteNudgeFlagLoadable } from '@confluence/contextual-invite-nudge-flag';
import { Attribution, withTransparentErrorBoundary } from '@confluence/error-boundary';

import { useLivePageInviteNudgeV2Eligible } from '../hooks/useLivePageInviteNudgeV2Eligible/useLivePageInviteNudgeV2Eligible';

import { useLivePageInviteNudgeStore } from './useLivePageInviteNudgeStore';

const LivePageInviteNudgeComponent = () => {
	const [{ hasLivePageChanges }] = useLivePageInviteNudgeStore();
	const { isEligible } = useLivePageInviteNudgeV2Eligible();

	if (!isEligible || !hasLivePageChanges) {
		return null;
	}

	return <ContextualInviteNudgeFlagLoadable source="live-page" />;
};

export const LivePageInviteNudge = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ADOPTION,
})(LivePageInviteNudgeComponent);
